import * as angular from 'angular';

import { ConversionDTO } from '../../models';
import { IRequestService } from '../../services';

export interface IConversionService {
    convert: (data: ConversionDTO) => angular.IPromise<ConversionDTO>;
}

export class ConversionService implements IConversionService {
    static serviceId = 'conversionService';

    private _controllerUrl: string;

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    private controllerUrl() {
        if (!this._controllerUrl) {
            this._controllerUrl = 'conversion/';
        }
        return this._controllerUrl;
    }

    convert(data: ConversionDTO): angular.IPromise<ConversionDTO> {
        const url = this.controllerUrl() + 'convert';
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.postAtV1(url, data);
    }
}
